export default __webpack_public_path__ + "static/char-s-18-chs-d1c8554a8ebdacd8f1e57dedaa8e56fb.png";